import { render, staticRenderFns } from "./giftItemEdit.vue?vue&type=template&id=dffa6fbc&scoped=true&"
import script from "./giftItemEdit.vue?vue&type=script&lang=js&"
export * from "./giftItemEdit.vue?vue&type=script&lang=js&"
import style0 from "./giftItemEdit.vue?vue&type=style&index=0&id=dffa6fbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffa6fbc",
  null
  
)

export default component.exports